module.exports = __webpack_public_path__ + "static/media/close-session-blue-icon.956f5c7e.svg";